import { render, staticRenderFns } from "./DataGatheringCardTitle.vue?vue&type=template&id=37837276&scoped=true&"
import script from "./DataGatheringCardTitle.vue?vue&type=script&lang=js&"
export * from "./DataGatheringCardTitle.vue?vue&type=script&lang=js&"
import style0 from "./DataGatheringCardTitle.vue?vue&type=style&index=0&id=37837276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37837276",
  null
  
)

export default component.exports